import React, { createContext, useContext, useMemo, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Loader } from '@refera/ui-web'

const TriageFormContext = createContext({})

function TriageFormProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false)
  const methods = useForm({ mode: 'all', shouldUnregister: false })

  return (
    <>
      <TriageFormContext.Provider
        value={useMemo(() => ({ isLoading, setIsLoading }), [isLoading, setIsLoading])}
      >
        <FormProvider {...methods}>{children}</FormProvider>
      </TriageFormContext.Provider>
      <Loader open={isLoading} hasBackdrop />
    </>
  )
}

/**
 * @typedef {Object} ContextValue
 * @property {Boolean} isLoading Estado de carregamento do formulário de triagem
 * @property {Function} setIsLoading Função para definir o estado de carregamento do formulário de triagem
 */

/**
 * Hook para utilizar o formulário de triagem
 * @returns {ContextValue} Objeto com os métodos e estado do formulário de triagem
 */
function useTriageForm() {
  const context = useContext(TriageFormContext)

  if (!context) throw new Error('useTriageForm must be used within a TriageFormProvider')
  return context
}

export { TriageFormProvider, useTriageForm }
